import { Route } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import { useSelector } from 'react-redux';
import useCasinoRoutes from '~/components/router/use-casino-routes';
import NavBar from '~/components/casino-shared/navbar/navbar-async';
import { selectCasinoMaintenanceEnabled } from '~/components/brand/ducks/selectors';
import NullLoader from '~/components/null-loader';

const RoutesNavbar = () => {
	const isCasinoMaintenanceEnabled = useSelector(selectCasinoMaintenanceEnabled);
	const { ROUTE_CASINO, ROUTE_LIVE_CASINO } = useCasinoRoutes();

	return (
		<TracedRoutes>
			<Route index />
			<Route path={`${ROUTE_LIVE_CASINO}/*`} element={<NavBar />} />
			{!isCasinoMaintenanceEnabled && <Route path={`${ROUTE_CASINO}/*`} element={<NavBar />} />}
			<Route path="*" element={<NullLoader />} />
		</TracedRoutes>
	);
};

export default RoutesNavbar;
